export const responseErrorMessage = (value, fallback = "Unable to save the response. Please try again.") => {
    const body = value?.response?.data ?? value;
    const candidates = [body?.message, body?.error?.message, body?.error, value?.message, fallback];
    return candidates.find(message => typeof message === "string" && message.trim()) || "Unable to save the response. Please try again.";
};
